import React, { Component } from 'react';
import { Formik } from 'formik';
import { string, boolean, object } from 'yup';
import { FormGroup } from '../forms/FormBootstrap';

class CadastroLogin extends Component {

    constructor(props) {
        super(props);
        this.validationSchema = object().shape({
            emailLogin: 
                string()
                .label('Email')
                .email('E-mail inválido')
                .required('Digite seu e-mail')
                .test('ja-existe', 'Este e-mail já está cadastrado', async (value) => {
                    var texto = await (await fetch('cadastro/jaexisteemail?email=' + value)).json();
                    return texto === false;
                }),
            senha1: string()
                .label('Senha')
                .required('Escolha uma senha')
                .min(8, 'A senha deve ter pelo menos 8 caracteres'),
            senha2: string()
                .required('Confirme sua senha')
                .label('Confirme a senha')
                .test('senhas-conferem', 'Confime a senha igual à de cima', function (value) {
                    return this.parent.senha1 === value;
                }),
            termos: boolean()
                .label('Termos de uso')
                .test('is-true', 'Você precisa concordar com os termos de uso para continuar', value => value === true)
        });
    }

    onSubmit(values, actions) {
        if (this.props.onSubmit) {
            this.props.onSubmit(values, actions);
        } else {
            console.log("No onSubmit prop");
        }
    }


    render() {
        return <Formik
            onSubmit={(values, actions) => { this.onSubmit(values, actions) }}
            initialValues={{
                emailLogin: '',
                senha1: '',
                senha2: '',
                termos: false
            }}
            validateOnBlur={false}
            validateOnChange={false}
            validationSchema={this.validationSchema}
            render={(props) => {
                const {
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                } = props;

                return (
                    <React.Fragment>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-sm-6 col-sm-offset-3">
                                    <p>Crie uma conta gratuitamente, sem compromisso.</p>
                                    <p>Você tem 30 dias para experimentar o Perficio.</p>
                                    <p>Ao final do período de avaliação, se você não contratar o serviço, ele será cancelado automaticamente e não será gerada nenhuma fatura.</p>


                                </div>
                            </div>
                            <div className="tab-pane active" id="tabconta">
                                <div className="row">
                                    <FormGroup errors={errors} touched={touched} campo="emailLogin">
                                        <label htmlFor="emailLogin">E-mail</label>
                                        <input type="email" name="emailLogin" id="emailLogin" placeholder="meunome@gmail.com"
                                            aria-describedby="help-emailLogin"
                                            value={values.emailLogin}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control "
                                        />
                                    </FormGroup>
                                </div>
                                <div className="row">
                                    <FormGroup errors={errors} touched={touched} campo="senha1">
                                        <label htmlFor="senha1">Senha</label>
                                        <input type="password" name="senha1" id="senha1"
                                            aria-describedby="help-senha1"
                                            value={values.senha1}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control "
                                        />
                                    </FormGroup>
                                </div>
                                <div className="row">
                                    <FormGroup errors={errors} touched={touched} campo="senha2">
                                        <label htmlFor="senha2">Confirme a senha</label>
                                        <input type="password" name="senha2" id="senha2"
                                            aria-describedby="help-senha2"
                                            value={values.senha2}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control "
                                        />
                                    </FormGroup>
                                </div>
                                <div className="row">
                                    <FormGroup errors={errors} touched={touched} campo="termos">
                                        <div className="checkbox" data-th-if="${urltermosdeuso}">
                                            <label>
                                                <input type="checkbox" name="termos" onChange={handleChange} onBlur={handleBlur} /> Concordo com os <a href="termosdeuso.html"
                                                    target="_blank">Termos de uso</a>
                                            </label>
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="row">
                                    <div className="form-group col-sm-6 col-sm-offset-3">
                                        <a className="btn btn-link" href="login">Já possui uma conta? Clique aqui.</a>

                                        <button type="submit" className="btn btn-success pull-right">Criar conta</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </React.Fragment >
                );
            }
            } />
    }
}

export default CadastroLogin;